import { useQuery } from 'react-query';
import TrackerAPI, { TrackerType } from '@buildwise/libs/trackers/apis/TrackerAPI';
import { AxiosResponse } from 'axios';
import useUserData from 'hooks/useUserData';
import { ArticleUserMapType } from '@buildwise/pages/article/hooks/useArticleDetailsQuery';
import { useMemo } from 'react';
import { trackerQueryKeys } from './query-keys';

type TrackerDetailsResponse = {
  trackersList: TrackerType[];
  userMap: ArticleUserMapType;
};

export const useTrackerDetailsQuery = ({
  trackerId,
  shouldFetch = true,
}: {
  trackerId: string;
  shouldFetch?: boolean;
}) => {
  const { companyId } = useUserData();

  const { data, ...rest } = useQuery<AxiosResponse<TrackerDetailsResponse>, Error>({
    queryKey: trackerQueryKeys.getTrackerDetailsById(companyId, trackerId),
    queryFn: () => TrackerAPI.getTrackerDetails(companyId, trackerId),
    enabled: !!companyId && !!trackerId && shouldFetch,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
  });

  const tracker = useMemo(() => data?.data?.trackersList?.[0], [data]);

  return {
    tracker,
    userMap: data?.data?.userMap,
    ...rest,
  };
};

export default useTrackerDetailsQuery;
